import { expenseJobOrderColNm } from "constants/expenseJobOrderConstant";




export const printIncomeColumns = [
  {
      field: "No",
      headerName: "No.",
      printWidth: 0.3,
      printAlign: "center",
    },
    {
      field: "ExpNm",
      headerName: expenseJobOrderColNm.ExpNm,
      printWidth: 1.5,
    },
    {
      field: "Qty",
      headerName: "Qty",
      printWidth: 0.3,
      printAlign: "center",
    },
    {
      field: "CusRcptAmnt",
      headerName: "Advance",
      printWidth: 0.8,
      printType: "number",
      printAlign: "right",
    },
    {
      field: "OwnRcptAmnt",
      headerName: "Amount",
      printWidth: 0.8,
      printType: "number",
      printAlign: "right",
    },
]